/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreDTOsReplayTeamMetricsDtoSchema } from "./goodLuck/core/DTOs/replayTeamMetricsDtoSchema.ts";
import { z } from "zod/v4";

export const getBracketsMatchesMatchidTeamStatsPathParamsSchema = z.object({
  matchId: z.string(),
});

/**
 * @description OK
 */
export const getBracketsMatchesMatchidTeamStats200Schema = z.array(
  z.lazy(() => goodLuckCoreDTOsReplayTeamMetricsDtoSchema),
);

export const getBracketsMatchesMatchidTeamStatsQueryResponseSchema =
  getBracketsMatchesMatchidTeamStats200Schema;
